var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RunningProgramsAdmin',{attrs:{"kind":"hyrox"}})
}
var staticRenderFns = []

export { render, staticRenderFns }